import request from "@/utils/request";

// 查询充电站
export const getGroup = params => {
	return request({
		url: "/usergroup",
		method: "GET",
		params,
	});
};
